import { FlowNode } from '../types/workflow';

export function normalizeGoogleSheetsForApi(node: FlowNode): FlowNode {
  // Transform rowValues from formRepeater objects to plain value array
  const rawRows = node.data.rowValues;
  const rowValues = Array.isArray(rawRows)
    ? rawRows.map((item: any) => {
        const val = typeof item === 'object' && item !== null ? item.value : item;
        return val === null || val === undefined ? '' : String(val);
      })
    : [];

  // Rebuild data with only the fields the backend expects
  return {
    ...node,
    data: {
      accessToken: node.data.accessToken,
      refreshToken: node.data.refreshToken,
      expiresAt: node.data.expiryDate,
      spreadsheetId: node.data.spreadsheetId,
      sheetName: node.data.sheetName,
      email: node.data.googleEmail,
      rowValues,
      columnValues: node.data.columnHeaders,
    },
  };
}

export function normalizeGoogleSheetsForUI(node: FlowNode): FlowNode {
  if (node.type !== 'AddGoogleSheetRow') {
    return node;
  }

  const data = node.data || {};
  const normalizedData = { ...data };

  // Map email -> googleEmail
  if (data.email && !data.googleEmail) {
    normalizedData.googleEmail = data.email;
  }

  // Map columnValues -> columnHeaders
  if (data.columnValues && !data.columnHeaders) {
    normalizedData.columnHeaders = data.columnValues;
  }

  // Reconstruct rowValues to {id, columnName, value}[] for the formRepeater
  const headers = (normalizedData.columnHeaders || data.columnHeaders || []) as string[];
  const rawRowValues = data.rowValues;
  if (
    headers.length > 0 &&
    Array.isArray(rawRowValues) &&
    rawRowValues.length > 0 &&
    typeof rawRowValues[0] !== 'object'
  ) {
    normalizedData.rowValues = headers.map((header: string, index: number) => ({
      id: `col_loaded_${index}`,
      columnName: header,
      value: rawRowValues[index] !== undefined ? String(rawRowValues[index]) : '',
    }));
  }

  // Map expiresAt -> expiryDate
  if (data.expiresAt && !data.expiryDate) {
    normalizedData.expiryDate = data.expiresAt;
  }

  // Set previous values to avoid spurious emits on mount clearing data
  if (data.sheetName && !data._previousSheetName) {
    normalizedData._previousSheetName = data.sheetName;
  }
  if (data.spreadsheetId && !data._previousSpreadsheetId) {
    normalizedData._previousSpreadsheetId = data.spreadsheetId;
  }

  return {
    ...node,
    data: normalizedData,
  };
}
